// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanDto } from './IPlanDto';
import {
    IPlanDtoFromJSON,
    IPlanDtoFromJSONTyped,
    IPlanDtoToJSON,
    IPlanDtoToJSONTyped,
} from './IPlanDto';
import type { IReportHeader } from './IReportHeader';
import {
    IReportHeaderFromJSON,
    IReportHeaderFromJSONTyped,
    IReportHeaderToJSON,
    IReportHeaderToJSONTyped,
} from './IReportHeader';
import type { IClaimActivityBreakdownRecordDto } from './IClaimActivityBreakdownRecordDto';
import {
    IClaimActivityBreakdownRecordDtoFromJSON,
    IClaimActivityBreakdownRecordDtoFromJSONTyped,
    IClaimActivityBreakdownRecordDtoToJSON,
    IClaimActivityBreakdownRecordDtoToJSONTyped,
} from './IClaimActivityBreakdownRecordDto';

/**
 * 
 * @export
 * @interface IReportPageDtoClaimActivityBreakdownRecordDto
 */
export interface IReportPageDtoClaimActivityBreakdownRecordDto {
    /**
     * 
     * @type {Array<IReportHeader>}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    headers?: Array<IReportHeader>;
    /**
     * 
     * @type {Array<IPlanDto>}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    plans?: Array<IPlanDto>;
    /**
     * 
     * @type {Date}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    last_updated_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    date_to?: Date;
    /**
     * 
     * @type {Array<IClaimActivityBreakdownRecordDto>}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    content?: Array<IClaimActivityBreakdownRecordDto>;
    /**
     * 
     * @type {number}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    total_records?: number;
    /**
     * 
     * @type {number}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    page_number?: number;
    /**
     * 
     * @type {number}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    page_size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IReportPageDtoClaimActivityBreakdownRecordDto
     */
    has_next?: boolean;
}

/**
 * Check if a given object implements the IReportPageDtoClaimActivityBreakdownRecordDto interface.
 */
export function instanceOfIReportPageDtoClaimActivityBreakdownRecordDto(value: object): value is IReportPageDtoClaimActivityBreakdownRecordDto {
    return true;
}

export function IReportPageDtoClaimActivityBreakdownRecordDtoFromJSON(json: any): IReportPageDtoClaimActivityBreakdownRecordDto {
    return IReportPageDtoClaimActivityBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IReportPageDtoClaimActivityBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportPageDtoClaimActivityBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'headers': json['headers'] == null ? undefined : ((json['headers'] as Array<any>).map(IReportHeaderFromJSON)),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IPlanDtoFromJSON)),
        'last_updated_at': json['last_updated_at'] == null ? undefined : (new Date(json['last_updated_at'])),
        'date_from': json['date_from'] == null ? undefined : (new Date(json['date_from'])),
        'date_to': json['date_to'] == null ? undefined : (new Date(json['date_to'])),
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IClaimActivityBreakdownRecordDtoFromJSON)),
        'total_records': json['total_records'] == null ? undefined : json['total_records'],
        'page_number': json['page_number'] == null ? undefined : json['page_number'],
        'page_size': json['page_size'] == null ? undefined : json['page_size'],
        'has_next': json['has_next'] == null ? undefined : json['has_next'],
    };
}

export function IReportPageDtoClaimActivityBreakdownRecordDtoToJSON(json: any): IReportPageDtoClaimActivityBreakdownRecordDto {
    return IReportPageDtoClaimActivityBreakdownRecordDtoToJSONTyped(json, false);
}

export function IReportPageDtoClaimActivityBreakdownRecordDtoToJSONTyped(value?: IReportPageDtoClaimActivityBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headers': value['headers'] == null ? undefined : ((value['headers'] as Array<any>).map(IReportHeaderToJSON)),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IPlanDtoToJSON)),
        'last_updated_at': value['last_updated_at'] == null ? undefined : ((value['last_updated_at']).toISOString()),
        'date_from': value['date_from'] == null ? undefined : ((value['date_from']).toISOString().substring(0,10)),
        'date_to': value['date_to'] == null ? undefined : ((value['date_to']).toISOString().substring(0,10)),
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IClaimActivityBreakdownRecordDtoToJSON)),
        'total_records': value['total_records'],
        'page_number': value['page_number'],
        'page_size': value['page_size'],
        'has_next': value['has_next'],
    };
}

